<template>
    <div>
        <!-- Breadcrumb Start-->
        <div class="section-breadcrumb">
            <div class="container">
                <div class="row">
                    <div class="col-md-12 justify-content-center align-self-center pb-2">
                        <ul class="breadcrumb-link text-center list-unstyled mb-0">
                            <li class="text-white"><a href="#">Home</a></li>
                            <li class="text-white active">Blog</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <!-- Breadcrumb End -->
        <!-- Blog Section Start-->
        <section class="section section-blog">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="mb-3 wow fadeInUp" data-wow-duration="1.5s" style="visibility: visible; animation-duration: 1.5s; animation-name: fadeInUp;">
                            <h1 class="font-weight-bold section-h1">
                                Blog
                            </h1>
                            <p class="f-18 text-left">
                                dolor sit amet, consectetur adipiscing elit. Quisque rutrum pellentesque imperdiet. Nulla lacinia iaculis nulla non pulvinar. Sociis natoque penatibus et magnis dis parturient montes.
                                dolor sit amet, consectetur adipiscing elit. Quisque rutrum pellentesque imperdiet. Nulla lacinia iaculis nulla non pulvinar. Sociis natoque penatibus et magnis dis parturient montes.
                            </p>
                            <hr class="hr-border">
                        </div>
                    </div>
                    <div class="col-lg-3 order-lg-2 wow fadeIn" data-wow-delay="0.1s" data-wow-duration="1.5s">
                        <aside class="sidebar mb-3">
                            <div class="input-group mb-3 pb-1">
                                <input class="form-control" placeholder="Search..." type="text">
                                <span class="input-group-append">
                                    <button type="submit" class="btn btn-dark btn-search p-2">
                                        <span class="mdi mdi-magnify"></span>
                                    </button>
                                </span>
                            </div>
                            <h5 class="pt-4 text-uppercase font-weight-bold">Categories</h5>
                            <ul class="nav nav-list flex-column mb-4 list-unstyled">
                                <li class="nav-item">
                                    <a class="nav-link" href="#">
                                        <i class="mdi mdi-chevron-right"></i>Abarelix (2)
                                    </a>
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link active" href="#">
                                        <i class="mdi mdi-chevron-right"></i>Baclofen (4)
                                    </a>
                                    <ul>
                                        <li class="nav-item">
                                            <a class="nav-link" href="#">
                                                <i class="mdi mdi-chevron-right"></i>Factrel
                                            </a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link active" href="#">
                                                <i class="mdi mdi-chevron-right"></i>Jalyn
                                            </a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link" href="#">
                                                <i class="mdi mdi-chevron-right"></i>Mesna
                                            </a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link" href="#">
                                                <i class="mdi mdi-chevron-right"></i>Sabril
                                            </a>
                                        </li>
                                    </ul>
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link" href="#">
                                        <i class="mdi mdi-chevron-right"></i>Lamisil (3)
                                    </a>
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link" href="#">
                                        <i class="mdi mdi-chevron-right"></i>Jevtana (2)
                                    </a>
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link" href="#">
                                        <i class="mdi mdi-chevron-right"></i>Danazol (1)
                                    </a>
                                </li>
                            </ul>

                            <div class="pb-2 mb-3">
                                <ul class="blog-news d-flex align-items-center list-unstyled">
                                    <li class="blog-item active w-100">
                                        <a class="blog-link text-uppercase font-weight-bold d-block text-center" href="#">Popular</a>
                                    </li>
                                </ul>

                                <div class="blog-news-content">
                                    <div class="blog-post-list">
                                        <ul class="list-unstyled">
                                            <li>
                                                <div class="blog-post-image mr-2">
                                                    <div class="img-thumbnail no-borders">
                                                        <a href="#">
                                                            <img src="assets/images/blogs/blog-1.jpg" width="50" height="50" alt="">
                                                        </a>
                                                    </div>
                                                </div>
                                                <div class="blog-post-info">
                                                    <a href="#">Nullam Vitae Nibh Un Odiosters</a>
                                                    <div class="blog-post-meta"> Nov 10,2020</div>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="blog-post-image mr-2">
                                                    <div class="img-thumbnail no-borders">
                                                        <a href="#">
                                                            <img src="assets/images/blogs/blog-2.jpg" width="50" height="50" alt="">
                                                        </a>
                                                    </div>
                                                </div>
                                                <div class="blog-post-info">
                                                    <a href="#">Nullam Vitae Nibh Un Odiosters</a>
                                                    <div class="blog-post-meta"> Nov 10,2020</div>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="blog-post-image mr-2">
                                                    <div class="img-thumbnail no-borders">
                                                        <a href="#">
                                                            <img src="assets/images/blogs/blog-3.jpg" width="50" height="50" alt="">
                                                        </a>
                                                    </div>
                                                </div>
                                                <div class="blog-post-info">
                                                    <a href="#">Nullam Vitae Nibh Un Odiosters</a>
                                                    <div class="blog-post-meta"> Nov 10,2020</div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="pb-2">
                                <ul class="blog-news d-flex align-items-center list-unstyled">
                                    <li class="blog-item active w-100">
                                        <a class="blog-link text-uppercase font-weight-bold d-block text-center" href="#">Recent</a>
                                    </li>
                                </ul>

                                <div class="blog-news-content">
                                    <div class="blog-post-list">
                                        <ul class="list-unstyled">
                                            <li>
                                                <div class="blog-post-image mr-2">
                                                    <div class="img-thumbnail no-borders">
                                                        <a href="#">
                                                            <img src="assets/images/blogs/blog-1.jpg" width="50" height="50" alt="">
                                                        </a>
                                                    </div>
                                                </div>
                                                <div class="blog-post-info">
                                                    <a href="#">Nullam Vitae Nibh Un Odiosters</a>
                                                    <div class="blog-post-meta"> Nov 10,2020</div>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="blog-post-image mr-2">
                                                    <div class="img-thumbnail no-borders">
                                                        <a href="#">
                                                            <img src="assets/images/blogs/blog-2.jpg" width="50" height="50" alt="">
                                                        </a>
                                                    </div>
                                                </div>
                                                <div class="blog-post-info">
                                                    <a href="#">Nullam Vitae Nibh Un Odiosters</a>
                                                    <div class="blog-post-meta"> Nov 10,2020</div>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="blog-post-image mr-2">
                                                    <div class="img-thumbnail no-borders">
                                                        <a href="#">
                                                            <img src="assets/images/blogs/blog-3.jpg" width="50" height="50" alt="">
                                                        </a>
                                                    </div>
                                                </div>
                                                <div class="blog-post-info">
                                                    <a href="#">Nullam Vitae Nibh Un Odiosters</a>
                                                    <div class="blog-post-meta"> Nov 10,2020</div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </aside>
                    </div>
                    <div class="col-lg-9 order-lg-1 wow fadeIn" data-wow-delay="0.1s" data-wow-duration="1.5s">
                        <article class="blog-post-left mb-4 pb-4">
                            <div class="row mb-3">
                                <div class="col-lg-5">
                                    <div class="post-image">
                                        <a href="#">
                                            <img src="assets/images/blogs/blog-2.jpg" class="img-fluid img-thumbnail no-borders" alt="">
                                        </a>
                                    </div>
                                </div>
                                <div class="col-lg-7">
                                    <div class="blog-post-content">
                                        <h4>
                                            <a href="#" class="text-left text-body font-weight-bold">
                                                This is a stardard post with preview image
                                            </a>
                                        </h4>
                                        <p class="text-left">
                                            Euismod atras vulputate iltricies etri elit. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Nulla nunc dui, tristique in semper vel, congue sed ligula. Nam dolor ligula, faucibus id sodales in, auctor fringilla libero. Pellentesque pellentesque tempor tellus eget hendrerit. Morbi id aliquam ligula. Aliquam id dui sem. Proin rhoncus consequat nisl, eu ornare mauris tincidunt vitae. [...]
                                        </p>
                                        <span class="blog-readmore-btn d-sm-block d-inline-block ">
                                            <a href="#" class="theme-btn btn btn-xs btn-light text-uppercase">Read More</a>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <div class="blog-post-inner">
                                        <span>
                                            <span class="mdi mdi-calendar-month"> January 10, 2020 </span>
                                        </span>
                                        <span>
                                            <span class="mdi mdi-account-outline"> By <a href="#"> John Doe </a> </span>
                                        </span>
                                        <span>
                                            <span class="mdi mdi-folder-outline"></span>
                                            <a href="#">Lifestyle</a>, <a href="#">Design</a>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </article>
                        <article class="blog-post-left mb-4 pb-4">
                            <div class="row mb-3">
                                <div class="col-lg-5">
                                    <div class="post-image">
                                        <a href="#">
                                            <img src="assets/images/blogs/blog-1.jpg" class="img-fluid img-thumbnail no-borders" alt="">
                                        </a>
                                    </div>
                                </div>
                                <div class="col-lg-7">
                                    <div class="blog-post-content">
                                        <h4>
                                            <a href="#" class="text-left text-body font-weight-bold">
                                                This is a stardard post with preview image
                                            </a>
                                        </h4>
                                        <p class="text-left">
                                            Euismod atras vulputate iltricies etri elit. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Nulla nunc dui, tristique in semper vel, congue sed ligula. Nam dolor ligula, faucibus id sodales in, auctor fringilla libero. Pellentesque pellentesque tempor tellus eget hendrerit. Morbi id aliquam ligula. Aliquam id dui sem. Proin rhoncus consequat nisl, eu ornare mauris tincidunt vitae. [...]
                                        </p>
                                        <span class="blog-readmore-btn d-sm-block d-inline-block ">
                                            <a href="#" class="theme-btn btn btn-xs btn-light text-uppercase">Read More</a>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <div class="blog-post-inner">
                                        <span>
                                            <span class="mdi mdi-calendar-month"> January 10, 2020 </span>
                                        </span>
                                        <span>
                                            <span class="mdi mdi-account-outline"> By <a href="#"> John Doe </a> </span>
                                        </span>
                                        <span>
                                            <span class="mdi mdi-folder-outline"></span>
                                            <a href="#">Lifestyle</a>, <a href="#">Design</a>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </article>
                        <article class="blog-post-left mb-4 pb-4">
                            <div class="row mb-3">
                                <div class="col-lg-5">
                                    <div class="post-image">
                                        <a href="#">
                                            <img src="assets/images/blogs/blog-3.jpg" class="img-fluid img-thumbnail no-borders" alt="">
                                        </a>
                                    </div>
                                </div>
                                <div class="col-lg-7">
                                    <div class="blog-post-content">
                                        <h4>
                                            <a href="#" class="text-left text-body font-weight-bold">
                                                This is a stardard post with preview image
                                            </a>
                                        </h4>
                                        <p class="text-left">
                                            Euismod atras vulputate iltricies etri elit. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Nulla nunc dui, tristique in semper vel, congue sed ligula. Nam dolor ligula, faucibus id sodales in, auctor fringilla libero. Pellentesque pellentesque tempor tellus eget hendrerit. Morbi id aliquam ligula. Aliquam id dui sem. Proin rhoncus consequat nisl, eu ornare mauris tincidunt vitae. [...]
                                        </p>
                                        <span class="blog-readmore-btn d-sm-block d-inline-block ">
                                            <a href="#" class="theme-btn btn btn-xs btn-light text-uppercase">Read More</a>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <div class="blog-post-inner">
                                        <span>
                                            <span class="mdi mdi-calendar-month"> January 10, 2020 </span>
                                        </span>
                                        <span>
                                            <span class="mdi mdi-account-outline"> By <a href="#"> John Doe </a> </span>
                                        </span>
                                        <span>
                                            <span class="mdi mdi-folder-outline"></span>
                                            <a href="#">Lifestyle</a>, <a href="#">Design</a>
                                        </span>

                                    </div>
                                </div>
                            </div>
                        </article>
                        <article class="blog-post-left mb-4 pb-4">
                            <div class="row mb-3">
                                <div class="col-lg-5">
                                    <div class="post-image">
                                        <a href="#">
                                            <img src="assets/images/blogs/blog-2.jpg" class="img-fluid img-thumbnail no-borders" alt="">
                                        </a>
                                    </div>
                                </div>
                                <div class="col-lg-7">
                                    <div class="blog-post-content">
                                        <h4>
                                            <a href="#" class="text-left text-body font-weight-bold">
                                                This is a stardard post with preview image
                                            </a>
                                        </h4>
                                        <p class="text-left">
                                            Euismod atras vulputate iltricies etri elit. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Nulla nunc dui, tristique in semper vel, congue sed ligula. Nam dolor ligula, faucibus id sodales in, auctor fringilla libero. Pellentesque pellentesque tempor tellus eget hendrerit. Morbi id aliquam ligula. Aliquam id dui sem. Proin rhoncus consequat nisl, eu ornare mauris tincidunt vitae. [...]
                                        </p>
                                        <span class="blog-readmore-btn d-sm-block d-inline-block ">
                                            <a href="#" class="theme-btn btn btn-xs btn-light text-uppercase">Read More</a>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <div class="blog-post-inner">
                                        <span>
                                            <span class="mdi mdi-calendar-month"> January 10, 2020 </span>
                                        </span>
                                        <span>
                                            <span class="mdi mdi-account-outline"> By <a href="#"> John Doe </a> </span>
                                        </span>
                                        <span>
                                            <span class="mdi mdi-folder-outline"></span>
                                            <a href="#">Lifestyle</a>, <a href="#">Design</a>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </article>

                        <ul class="pagination float-right">
                            <li class="page-item">
                                <a href="#" class="page-link">
                                    <i class="mdi mdi-chevron-left"></i>
                                </a>
                            </li>
                            <li class="page-item active">
                                <a href="#" class="page-link">1</a>
                            </li>
                            <li class="page-item">
                                <a href="#" class="page-link">2</a>
                            </li>
                            <li class="page-item">
                                <a href="#" class="page-link">3</a>
                            </li>
                            <li class="page-item">
                                <a href="#" class="page-link">
                                    <i class="mdi mdi-chevron-right"></i>
                                </a>
                            </li>
                        </ul>
                    </div>

                </div>
            </div>
        </section>
        <!-- Blog Section End-->
    </div>
</template>
<script>
    export default {
        name: "blog",
        mounted() {
            this.init();
        },
        methods: {
            init() {
                this.hidePreloader();
            },

            /*----PRELOADER-----*/
            hidePreloader() {
                var preloaderFadeOutTime = 500;
                var preloader = $('.spinner-wrapper');
                setTimeout(function () {
                    preloader.fadeOut(preloaderFadeOutTime);
                }, 500);
            }

        }
    }</script>
